import React from 'react';
import { Clock, Euro, UserCheck, Award } from 'lucide-react';
import { benefits } from '../data/mock';

const iconMap = {
  Clock: Clock,
  Euro: Euro,
  UserCheck: UserCheck,
  Award: Award
};

const BenefitCard = ({ benefit }) => {
  const IconComponent = iconMap[benefit.icon];

  return (
    <div className="text-center">
      {/* Icon Circle */}
      <div className={`w-16 h-16 ${benefit.iconBgColor} rounded-full flex items-center justify-center mx-auto mb-4`}>
        <IconComponent className={`w-7 h-7 ${benefit.iconColor}`} />
      </div>

      {/* Title */}
      <h3 className="text-lg font-bold text-gray-900 mb-2">{benefit.title}</h3>

      {/* Description */}
      <p className="text-gray-600 text-sm leading-relaxed">{benefit.description}</p>
    </div>
  );
};

const BenefitsSection = () => {
  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Pourquoi nous choisir ?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Des avantages qui font la différence pour votre entreprise
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {benefits.map((benefit) => (
            <BenefitCard key={benefit.id} benefit={benefit} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
